module.exports = __webpack_public_path__ + "static/media/search.bb051886.svg";